<template>
  <div class="formation">
    <a target="_blank" :href="item.pdf">
      <pdf ref="pdf" :src="item.pdf" :resize="true" :text="false">
        <template slot="loading">
        </template>
      </pdf>
    </a>
  </div>
</template>

<script>
  import pdf from 'pdfvuer'

  export default {
    name: 'Formation',
    components: {
      pdf
    },
    data() {
      return {
        item: {
          pdf: "https://www.asspm.fr/rubriques/DEVIENS-ARBITRE-OFFICIEL.pdf"
        }
      }
    }
  }

</script>